import React, { useRef, useState, useEffect, forwardRef } from 'react';
import ReactTooltip from 'react-tooltip';
import S from './style';
import { getUserId } from '../../services/firebaseInit';

const CardItem = forwardRef((properties, reference) => {
  const {
    data,
    onAddCard,
    onEditCard,
    onDeleteCard,
    onVoteCard,
    onUnvoteCard,
    readOnly,
    isDraggable,
    isVotable = false,
    isVoteVisible,
    isNewCard,
    ...restProperties
  } = properties;

  const textFieldReference = useRef(null);
  const [text, setText] = useState('');

  useEffect(() => {
    if (isNewCard) textFieldReference.current.focus();
  }, [isNewCard]);

  useEffect(() => {
    setText(data.description);
  }, [data]);

  const onRemoveCard = () => {
    if (onDeleteCard) onDeleteCard();
  };

  const handleChange = (event) => {
    setText(event.target.value);
  };

  const handleBlur = () => {
    if (text.length === 0) {
      onRemoveCard();
    } else {
      onEditCard(text);
    }
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (text.length === 0) {
        handleBlur();
      } else {
        handleBlur();
        onAddCard();
      }
    }
  };

  const isVoted = () => data.votes.includes(getUserId());

  const handleVoteClick = () => {
    if (isVoted()) {
      onUnvoteCard();
    } else if (isVotable) {
      onVoteCard();
    }
  };

  return (
    <S.WrapperDragger ref={reference} {...restProperties}>
      <S.Wrapper>
        {isDraggable && (
          <S.Dragger>
            <S.DraggerIcon />
            <S.DraggerIcon />
          </S.Dragger>
        )}

        <S.TextArea
          ref={textFieldReference}
          value={text}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          readOnly={readOnly}
          isDraggable={isDraggable}
          autofocus={isNewCard}
        />

        {!readOnly && !isNewCard && (
          <S.IconsHover>
            <S.DeleteIcon onClick={onRemoveCard} />
          </S.IconsHover>
        )}

        {isVoteVisible && (
          <>
            <S.IconsHover isVisible={isVoteVisible}>
              <S.WrapperIconVote voted={isVoted() ? 1 : 0}>
                <S.LikeIcon
                  data-tip="No votes left"
                  data-tip-disable={isVoted() || isVotable}
                  data-class="tooltip"
                  isVotable={isVotable}
                  voted={isVoted() ? 1 : 0}
                  onClick={handleVoteClick}
                />
              </S.WrapperIconVote>
            </S.IconsHover>
            <ReactTooltip place="top" effect="solid" border />
          </>
        )}
      </S.Wrapper>
    </S.WrapperDragger>
  );
});

CardItem.displayName = 'CardItem';

export default CardItem;
